<!-- 账户查询-详情 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container view-account">
      <el-form v-loading="formLoading" :model="viewObj" label-width="110px" size="mini">
        <!-- 用户编码 -->
        <el-form-item :label="$t('fiPayAdvice.userCode')+ ':'">{{ viewObj.userCode }}</el-form-item>
        <!-- 账户类型 -->
        <el-form-item :label="$t('title.accout.type')+ ':'">{{ $lt(initDict.acType, viewObj.acType) }}</el-form-item>
        <!-- 单据类型 -->
        <el-form-item :label="$t('fiAcInput.orderType')+ ':'">
          <span v-if="viewObj.orderType === 'A01'">{{ $t('efubo.card.record.type2') }}</span>
          <span v-else-if="viewObj.orderType === 'A02'">{{ $t('member.tx') }}</span>
          <span v-else-if="viewObj.orderType === 'A05'">{{ $t('menu.purgoods') }}</span>
          <span v-else>{{ $lt(initDict.orderType, viewObj.orderType) }}</span>
        </el-form-item>
        <!-- 金额 -->
        <el-form-item :label="$t('pmEfuboCard.amount')+ ':'">{{ viewObj.money }}</el-form-item>
        <!-- 余额 -->
        <el-form-item :label="$t('bdBounsDeduct.remainMoney')+ ':'">{{ viewObj.balance }}</el-form-item>
        <!-- 可用余额 -->
        <el-form-item :label="$t('busi.fi.valid.balance')+ ':'">{{ viewObj.validBalance }}</el-form-item>
        <!-- 借款余额 -->
        <el-form-item :label="$t('busi.fi.owe.balance')+ ':'">{{ viewObj.oweBalance }}</el-form-item>
        <div v-if="this.language === 'zh_CN'">
          <!-- 备注 -->
          <el-form-item :label="$t('poLpOrder.remark')+ ':'">{{ viewObj.memo }}</el-form-item>
          <!-- 摘要 -->
          <el-form-item :label="$t('sys.notes')+ ':'">{{ viewObj.remark }}</el-form-item>
        </div>
        <!-- 创建时间 -->
        <el-form-item :label="$t('Common.createTime')+ ':'">{{ viewObj.createTime }}</el-form-item>
        <div style="text-align: center; margin-bottom: 10px">
          <el-button icon="el-icon-close" @click="$router.back(-1)">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { balanceView } from "@/api/ay-account-manager"

export default {
  name: "ViewAccount",
  data() {
    return {
      viewObj: {},
      initDict: {
        acType: 'fiacinput.actype.cn',
        orderType: 'ac_change_order_type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'language',
    ])
  },
  created() {
    this.formLoading = true
    this.viewId = this.$route.params.id
    balanceView({ 'id': this.$route.params.id }).then(res => {
      this.viewObj = res.data
      this.formLoading = false
    }).catch(() => {
      this.$message.error(this.$t('bdSendRegister.operaterFail'))
      this.$router.go(-1)
    })
  }
}
</script>

<style scoped>

</style>